import axios from "axios";
import OrderFormStep from "../common/OrderFormStep";
import Config from "../common/Config";
import OrderFormType from "../common/OrderFormType";

export default class Review extends OrderFormStep {
  constructor(props) {
    super(props);

    this.patientInfo1UomMetric = 1;
    this.patientInfo1UomImperial = 2;
    this.ThermolynId = 105;
    this.polypropyleneCopolymerSelectedId = 109;
    this.noInsertSelected = "No Insert";

    this.state = {
      accountNumber: null,
      clinicName: null,
      prosthetistName: null,
      email: null,
      poNumber: null,
      shippingAddress1: null,
      shippingAddress2: null,
      city: null,
      stateName: null,
      zip: null,
      phone: null,
      contactMethodName: null,
      shippingCarrierName: null,
      shippingMethodName: null,
      patientName: null,
      patientId: null,
      patientInfo1UOM: null,
      patientInfo1UOMName: null,
      height: null,
      weight: null,
      isBilateral: null,
      amputationLevel: null,
      kLevel: null,
      footDirection: null,
      footSize: null,
      estimatedShipDate: null,
      itemsSentIn: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    try {
      let config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
      };

      if (this.props.uniqueId != null) {
        config.headers.UniqueId = this.props.uniqueId;
      }

      let clinicInfoData = (
        await axios.get(
          Config.baseApiUrl + "clinicInfos/" + this.props.formTypeId,
          config
        )
      ).data;
      let notes = (
        await axios.get(
          Config.baseApiUrl + "notes/" + this.props.formTypeId,
          config
        )
      ).data;

      let estimatedShipDate = (
        await axios.get(
          Config.baseApiUrl + "shipDate/" + this.props.formTypeId,
          config
        )
      ).data;

      let patientInfo1Config = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: ["patientInfo1UOM", "height", "weight"],
        },
      };

      if (this.props.uniqueId != null) {
        patientInfo1Config.headers.UniqueId = this.props.uniqueId;
      }

      let patientInfo1Data = (
        await axios.get(
          Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
          patientInfo1Config
        )
      ).data;

      let fieldInputConfig = {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token"))?.access_token,
        },
        params: {
          fieldNames: [
            "amputationLevel",
            "kLevel",
            "footDirection",
            "footSize",
            "itemsSentIn",
          ],
        },
      };

      if (this.props.uniqueId != null) {
        fieldInputConfig.headers.UniqueId = this.props.uniqueId;
        config.headers.UniqueId = this.props.uniqueId;
      }

      let fieldInputs = (
        await axios.get(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
          fieldInputConfig
        )
      ).data;

      if(clinicInfoData) {
        this.setState({
          accountNumber: clinicInfoData.accountNumber,
          clinicName: clinicInfoData.clinicName,
          prosthetistName: clinicInfoData.prosthetistName,
          email: clinicInfoData.email,
          poNumber: clinicInfoData.poNumber,
          shippingAddress1: clinicInfoData.shippingAddress1,
          shippingAddress2: clinicInfoData.shippingAddress2,
          city: clinicInfoData.city,
          stateName: clinicInfoData.stateName,
          zip: clinicInfoData.zip,
          phone: this.formatPhone(clinicInfoData.phone),
          contactMethodName: clinicInfoData.contactMethodName,
          shippingCarrierName: clinicInfoData.shippingCarrierName,
          shippingMethodName: clinicInfoData.shippingMethodName,
        });
      }

      if(patientInfo1Data) {
        this.setState({
          patientName: patientInfo1Data.patientName,
          patientId: patientInfo1Data.patientId,
          isBilateral: this.getYesNo(patientInfo1Data.isBilateral),
          notes: notes.data,
          estimatedShipDate: estimatedShipDate,
          patientInfo1UOM: patientInfo1Data.fieldInputs?.find(
            (fi) => fi.fieldName === "patientInfo1UOM"
          )?.fieldOptionId,
          patientInfo1UOMName: patientInfo1Data.fieldInputs?.find(
            (fi) => fi.fieldName === "patientInfo1UOM"
          )?.fieldOptionName,
          amputationLevel: fieldInputs?.find(
            (fi) => fi.fieldName === "amputationLevel"
          )?.fieldOptionName,
          kLevel: fieldInputs?.find((fi) => fi.fieldName === "kLevel")?.fieldOptionName,
          footDirection: fieldInputs?.find(
            (fi) => fi.fieldName === "footDirection"
          )?.fieldOptionName,
          footSize: this.getFootSizeText(
            fieldInputs?.find((fi) => fi.fieldName === "footSize")?.numericData
          ),
          itemsSentIn: fieldInputs?.find((fi) => fi.fieldName === "itemsSentIn")
            ?.stringData
          });
  
        this.setState({
          height: this.getHeightText(
            patientInfo1Data.fieldInputs?.find((fi) => fi.fieldName === "height")?.numericData
          ),
          weight: this.getWeightText(
            patientInfo1Data.fieldInputs?.find((fi) => fi.fieldName === "weight")?.numericData
          )
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  async saveData() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    return axios.post(
      Config.baseApiUrl + "orders/" + this.props.formTypeId,
      null,
      config
    );
  }

  formatPhone(phone) {
    if (phone.length === 12) {
      return (
        "(" +
        phone.substr(2, 3) +
        ") " +
        phone.substr(5, 3) +
        "-" +
        phone.substr(8, 4)
      );
    }

    return phone;
  }

  getHeightText(height) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return height + " cm";
    } else {
      return Math.floor(height / 12) + "' " + (height % 12) + '"';
    }
  }

  getWeightText(weight) {
    if (this.state.patientInfo1UOM === this.patientInfo1UomMetric) {
      return weight + " kg";
    } else {
      return weight + " lbs";
    }
  }

  getYesNo(boolData) {
    return boolData ? "Yes" : "No";
  }

  getFootSizeText(footSize) {
    return footSize + " cm";
  }

  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  render() {
    // This is always overridden
  }

  getFormTypeName() {
    if (this.props.formTypeId === OrderFormType.TFDefinitiveSocket) {
      return "TF Definitive Socket";
    } else if (this.props.formTypeId === OrderFormType.TTDefinitiveSocket) {
      return "TT Definitive Socket";
    } else if (this.props.formTypeId === OrderFormType.TTCheckSocket) {
      return "TT Check Socket";
    } else if (this.props.formTypeId === OrderFormType.TFCheckSocket) {
      return "TF Check Socket";
    } else if (this.props.formTypeId === OrderFormType.TTONESocket) {
      return "TT One® Socket";
    } else if (this.props.formTypeId === OrderFormType.TFONESocket) {
      return "TF One® Socket";
    }
  }

  renderFormSpecificFields() {}

  makeFieldOutput(fieldInputs) {
    if(!fieldInputs || !Array.isArray(fieldInputs)) {
      return;
    }

    return (
      <div>
        {fieldInputs.map((fi, index) => {
          if (fi === null || (fi.booleanData !== null && !fi.booleanData)) {
            return null;
          } else {
            return (
              <div key={index}>
                <p>{fi.fieldOptionName}</p>
                <span>{this.makePartNumbersOutput(fi.partNumbers)}</span>
              </div>
            );
          }
        })}
      </div>
    );
  }

  makePartNumbersOutput(partNumbers) {
    if (!partNumbers || partNumbers.length === 0) {
      return null;
    }

    let partNumberStr = partNumbers[0];

    if (partNumbers.length > 1) {
      partNumberStr += " & " + partNumbers[1];
    }

    return (
      <>
        {/* <br /> */}
        {/* <Form.Label className="footnote">{partNumberStr}</Form.Label> */}

        {partNumberStr}
      </>
    );
  }

  makeConditionalFieldOutput(fieldDisplayName, fieldInputs, propertyName, additionalText = "") {
    let value = this.getValueFromFieldInputs(fieldInputs, propertyName);
    if (value === null) {
      return null;
    }

    if (propertyName === "booleanData") {
      value = this.getYesNo(value);
    }

    return (
      <>
        <div style={{ display: "flex", gap: "8px" }}>
          <span>{fieldDisplayName}:</span> <p>{value} {additionalText}</p>
        </div>
      </>
    );
  }

  makeConditionalModificationFieldOutput(fieldDisplayName, fieldInputs, propertyName) {
    let value = this.getValueFromFieldInputs(fieldInputs, propertyName);
    if (value === null) {
      return null;
    }

    const symbol = (fieldDisplayName === "Percentage" ? "%" : " Ply");
    let newValue = "";
    if (value < 0) {
      let tempValue = value.toString();
      newValue = tempValue.replace("-", "");
      newValue += symbol + " Reduction";
    } else {
      newValue = value;
      newValue += symbol + " Increase";
    }

    return (
      <>
        <div style={{ display: "flex", gap: "8px" }}>
          <span>{fieldDisplayName}:</span> <p>{newValue}</p>
        </div>
      </>
    );
  }

  getValueFromFieldInputs(fieldInputs, propertyName) {
    if (fieldInputs === undefined || fieldInputs?.length === 0) {
      return null;
    }
    return fieldInputs[0][propertyName];;
  }

  imageMeasurementEntry(meas) {
    return <>{this.formatMeasurement(meas)}</>;
  }

  formatMeasurement(measurement) {
    if (this.state.uOM === "inches") {
      return `${measurement} in`;
    } else {
      return `${measurement} cm`;
    }
  }
  
  isFieldOutputNull(fieldInputs) {
    const children = fieldInputs.props.children;
    let isNull = true;
    children.forEach(c => {
      if (Boolean(c !== null)) {
        isNull = false;
        return;
      }
    });
    return isNull;
  };

}
